module.exports = __webpack_public_path__ + "img/Mädel.1c1a589f.jpg";